<script setup lang="ts">
type TwoFactorChannelData = App.Auth.Data.TwoFactorChannelData;

import Button from '@/components/button/Button.vue';
import Account2faChannel from '@/components/account/Account2faChannel.vue';

import Plus from '@/icons/line/plus.svg';

const props = defineProps<{
  channels?: TwoFactorChannelData[];
  tooltip?: string;
  userId?: number;
}>();

const user = useProperty<App.Auth.Data.UserData>('security.user');

const allowDeleteVerifiedChannels = computed(() => {
  return (props.channels ?? []).filter((channel) => channel.isVerified).length > 1;
});

const canAddChannel = computed(() => {
  return user.value && props.userId && user.value.id === props.userId;
});

function handle2faChannelDelete(channel: number) {
  useForm({
    method: 'DELETE',
    spoof: false,
    url: route('channel.delete', { channel }),
    updateInitials: true,
    fields: {},
    only: ['channels']
  }).submit();
}
</script>

<template>
  <ul class="flex flex-col divide-y divide-slate-200">
    <Account2faChannel
      v-for="channel in channels"
      :isVerified="channel.isVerified"
      :destination="channel.redactedDestination"
      :channelType="channel.channelTypeDisplayName"
      :allowDelete="!channel.isVerified || allowDeleteVerifiedChannels"
      :key="channel.id"
      :tooltip="tooltip"
      @onDelete="handle2faChannelDelete(channel.id)"
    />
  </ul>
  <div v-if="canAddChannel">
    <Button
      :href="route('account.two-factor.create')"
      color="secondary"
      variant="soft"
      size="sm"
      :iconLeft="Plus"
    >
      Add channel
    </Button>
  </div>
</template>
